module.exports = __webpack_public_path__ + "k-icons.1614657137767.eot";